module.exports = __webpack_public_path__ + "img/lishi.1f2baa28.png";